import React from 'react';
import { Spacings } from '@styles/index';
import Skeleton from '@material-ui/lab/Skeleton';
import styled from '@emotion/styled';

interface SkeletonProps {
  width?: string;
  height?: string;
  style?: React.CSSProperties;
}

const SkeletonWrapper = styled.div`
  .MuiSkeleton-text {
    transform: none;
  }
`;

const SubItemsSkeleton: React.FC<SkeletonProps> = ({
  width,
  height,
  style
}) => {
  return (
    <SkeletonWrapper>
      {[...Array(3)].map((_, index) => (
        <Skeleton
          key={String(index)}
          width={width}
          height={height}
          style={style}
        />
      ))}
    </SkeletonWrapper>
  );
};

SubItemsSkeleton.defaultProps = {
  width: '150px',
  height: `${Spacings.SPACING_3B}`,
  style: {
    backgroundColor: 'var(--color-divider)',
    borderRadius: `${Spacings.SPACING_2B}`,
    marginBottom: '24px',
    marginTop: '24px'
  }
};

export default SubItemsSkeleton;
